import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";

const CreaAprobadorAbas = () => {
  const [postVariable, setPostVariable] = useState([]);
  const [postLider, setPostLider] = useState([]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [options, setOptions] = useState([]);

  //se usa metodo GET para recibir la informacion de la API que necesitemos.

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/ObtenerUsuarios",
    })
      //nos da la respuesta mediante un mapeo
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.nombre,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://contratosback.azurewebsites.net/api/v1/CreaAprobadorAbastecimiento",
      data: {
        estado: postLider,
        idUsuario: postVariable.value,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(" creada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };
  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nuevo
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Asignación de usuario
                    </h6>
                    {/* Description */}
                    <div className="pl-lg-4">
                      <label
                        className="form-control-label"
                        htmlFor="input-address"
                      >
                        Seleccione el usuario
                      </label>
                      <FormGroup>
                        <Select
                          name="colors"
                          options={options}
                          classNamePrefix="select"
                          onChange={setPostVariable}
                        />
                      </FormGroup>
                      <select
                        id="tipoUsuarioID"
                        className="form-control"
                        onChange={(e) => setPostLider(e.target.value)}
                      >
                        <option value="">ES LIDER?...</option>
                        <option value="1">SI</option>
                        <option value="2">NO</option>
                      </select>
                      <hr />
                      <button
                        className="btn btn-primary btn-lg"
                        color="primary"
                        onClick={postData}
                      >
                        ENVIAR
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CreaAprobadorAbas;
